let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6H16x")).then(() => parcelRequire('5Tyyo'));